export { OwnersRemainingCaption } from './OwnersRemainingCaption'
